import React from "react";

const CustomAlert = ({type, message, visible}) => {
    return (
        visible ?
        <div className={`alert ${type}`} >
            <div className={`ri-alert-line icon ${type}`}></div>
            <div style={{ fontSize: "12px" }}>{message}</div>
        </div>
        : null
    );
};

export default CustomAlert;